<section class="mobile-boutiques-container">

  <h2 class="titre-mobile">Nos café jeux en boutique</h2>

  <div class="grille-ronds">

    <a *ngFor="let shop of boutiques" [href]="shop.lien" target="_blank" class="rond-boutique">
      
      <div class="bg-img" [style.background-image]="'url(' + shop.image + ')'"></div>
      
      <div class="overlay">
        <h3 class="ville">{{ shop.ville }}</h3>
        <span class="adresse">{{ shop.adresse }}</span>
      </div>
      
    </a>

  </div>

</section>